<template>
    <div class="pta-admin">
        <div class="page-titles border-bottom">
            <h3>AI Data & Notes</h3>
        </div>
        <div class="container-fluid p-0" style="font-size: 0.75em;">
          <div class="container-fluid p-20" style="font-size: 0.75em;">
            <div class="row">
              <div class="col-12">
                <transition name="fade">
                  <div class="card border-bottom" v-if="showFilterPanel">
                    <div class="card-body p-4">
                      <h4 class="card-title">{{trans('general.filter')}}</h4>
                      <div class="row">
                        <div class="col-6 col-sm-3">
                          <div class="form-group">
                            <label for="name">{{trans('transcript.title')}}</label>
                            <input class="form-control" id="title" name="title" v-model="filterTranscriptForm.title">
                          </div>
                        </div>
                        <div class="col-6 col-sm-3">
                          <div class="form-group">
                            <label for="email">{{trans('transcript.participants')}}</label>
                            <input class="form-control" id="participants" name="participants" v-model="filterTranscriptForm.speaker">
                          </div>
                        </div>
                      </div>
                      <button class="btn btn-danger btn-sm pull-right" v-if="showFilterPanel" @click="showFilterPanel = !showFilterPanel">{{trans('general.cancel')}}</button>
                    </div>
                  </div>
                </transition>
                <div class="card" v-if="transcripts.total">
                  <div class="card-body">
                    <div class="table-responsive" v-if="hasPermission('list-user') && transcripts.total">
                      <table class="table table-hover">
                        <thead>
                        <tr>
                          <th scope="col">{{trans('transcript.held_at')}}</th>
                          <th scope="col">{{trans('transcript.title')}}</th>
                          <th scope="col">{{trans('transcript.participants')}}</th>
                          <th scope="col">Limited Partner</th>
                          <th scope="col" class="table-option">{{trans('general.action')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="transcript in transcripts.data">
                          <td style="white-space:nowrap;">{{ transcript.held_at | momentDateTime }}</td>
                          <td v-text="transcript.title"></td>
                          <td style="max-width:500px;" class="pta-transcript-participants" v-html="transcript.speakers">
                            <!-- <span v-for="participant in transcript.participants">{{ participant.email }}</span> -->
                          </td>
                          <td v-if="transcript.investor">{{ transcript.investor.name }}</td>
                          <td v-else>-</td>
                          <td class="table-option">
                            <div class="btn-group">
                              <router-link :to="`/account/transcripts/${transcript.id}/meeting-minutes`" class="btn btn-info btn-sm" v-tooltip="trans('transcript.view_meeting_minutes')"><i class="fa-light fa-screen-users"></i></router-link>
                              <router-link :to="`/account/transcripts/${transcript.id}`" class="btn btn-info btn-sm" v-tooltip="'Data'"><i class="fa-light fa-scroll"></i></router-link>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <pagination-record :page-length.sync="filterTranscriptForm.page_length" :records="transcripts" @updateRecords="getTranscripts"></pagination-record>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import switches from 'vue-switches'
import vSelect from 'vue-multiselect'
import dateRangePicker from '../../components/date-range-picker'
import sortBy from '../../components/sort-by'

export default {
  components: {switches,vSelect,dateRangePicker,sortBy},
  data() {
    return {
      showCreatePanel: false,
      transcripts: {
        total: 0,
        data: []
      },
      filterTranscriptForm: {
        title: '',
        speaker: '',
        sort_by : 'held_at',
        order: 'desc',
        page_length: 100
      },
      showFilterPanel: false,
      orderByOptions: [
        {
          value: 'title',
          translation: i18n.transcript.title
        },
        {
          value: 'participants',
          translation: i18n.transcript.participants
        },
        {
          value: 'held_at',
          translation: i18n.transcript.held_at
        }
      ],
    };
  },
  mounted(){
    if(!helper.hasPermission('list-user') && !helper.hasPermission('create-user')){
      helper.notAccessibleMsg();
      this.$router.push('/account/dashboard');
    }
    this.getTranscripts();
  },
  methods: {
    hasPermission(permission){
      return helper.hasPermission(permission);
    },
    getTranscripts(page){
      if (typeof page !== 'number') {
        page = 1;
      }
      let url = helper.getFilterURL(this.filterTranscriptForm);
      axios.get('/api/transcript?page=' + page + url)
          .then(response => response.data)
          .then(response => {
            this.transcripts = response;
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    confirmDelete(user){
      return dialog => this.deleteTranscript(user);
    },
    deleteTranscript(user){
      axios.delete('/api/transcript/'+transcript.id)
          .then(response => response.data)
          .then(response => {
            toastr.success(response.message);
            this.getTranscripts();
          }).catch(error => {
        helper.showDataErrorMsg(error);
      });
    },
  },
  watch: {
    filterTranscriptForm: {
      handler(val){
        this.getTranscripts();
      },
      deep: true
    }
  },
  filters: {
    moment(date) {
      return helper.formatDate(date);
    },
    momentDateTime(date) {
      return helper.formatDateTime(date);
    }
  }
}
</script>
